<template>
  <div class="card card-user" style="box-shadow: none">
    <div slot="image" class="image">
      <!-- <img src="@/assets/img/bg5.jpg" alt="..."> -->
    </div>
    <div>
      <div class="author">
        <div style="position: relative;">

          <img id="profile-pic" :src="require('@/assets/img/proAvatar.png')" alt="avatar" v-if="!currentUser.profileImage" class="avatar border-gray" />
          <profile-image  :file-id="currentUser.profileImage" image-class="avatar border-gray" v-if="currentUser.profileImage" image-style="display: inline-block">
          </profile-image>
          <n-button type="primary" round="" icon="" @click.native="browseFiles()" class="browse-files-button">
            <i class="now-ui-icons design_image"></i>
          </n-button>
          <h5 class="title">{{ user.firstName }} {{ user.lastName }}</h5>
        </div>
        <p style="font-weight: 600" class="description">{{ user.username }}</p>
        <p class="description">{{ user.email }}</p>
        <p style="font-weight: 600" class="description">{{ user.mobileNumber }}</p>
        <p style="font-weight: 600" class="description"> {{ getAge(user.dob) }}</p>
        <div class="col-12 text-center mt-3">
          <div style="font-size: 30px">
            <span v-if="user.gender == 'male'" style="color: rgb(33, 150, 243)">
              <i class="fa fa-mars"></i>
            </span>
            <span v-if="user.gender == 'female'" style="color: rgb(235, 63, 157)">
              <i class="fa fa-venus"></i>
            </span>
            <span v-if="user.gender == 'others'" style="color: rgb(33, 243, 208)">
              <i class="fa fa-transgender-alt"></i>
            </span>
          </div>
        </div>
      </div>
      <!-- feature not in use -->
      <!-- <div style="text-align:center">
        <img style="height: 3em;" :src="require('@/assets/img/vitals/height.png')" />
        <span style="font-weight: 600;font-size: 1.14em;" class="description">5'9</span>
      </div> -->
    </div>

    <!--     <br />
    <div class="col-12">
      <h5>My Devices</h5>
      <hr>
      <div>
        <n-button type="primary" round>
          Connect
        </n-button>
      </div>
    </div> -->

    <div class="col-12" v-if="user.roles.includes('doctor')">
      <card>
        <h6>{{ $t("message.Signature") }}</h6>
        <div class="row">
          <div class="col-12 text-center">
            <dynamic-image :file-id="user.signature.image" image-class="mb-4" image-id="signature-img" image-style="margin: auto; display: block" v-if="user.signature.image">
            </dynamic-image>
            <n-button type="primary" round="" @click.native="browseSignatures()">{{ $t("message.Update Signature") }}</n-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  name: "profile",

  data() {
    return {
      tempUser:{}
    };
  },

  computed: {
    currentUser(){
      return this.$store.state.currentUser;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },
  async mounted() {
    this.tempUser = this.currentUser;
  },

  methods: {
    async browseFiles() {
      let that = this;
      let file = await chooser.getFile("image/*");

      if (file) {
        let loader = that.$loading.show({
          container: null,
          canCancel: false,
        });
        try {
          let response = await that.$store.dispatch("uploadFileToMinio", file);
          let user = JSON.parse(localStorage.user);
          let updateFields = {
            _id: user._id,
            profileImage: response.fileId,
          };
          user = await that.$store.dispatch("updateUserProfile", updateFields);
          localStorage.user = JSON.stringify(user);
          this.tempUser.profileImage = user.profileImage;
          this.$store.commit('setState', {
            stateName: 'user',
            stateValue: this.tempUser
          });
          $("#profile-pic").prop(
            "src",
            that.baseUrl + "/file/" + user.profileImage
          );
          loader.hide();

          swal.fire({
            type: "success",
            title: that.$t("message.Profile updated!"),
            text: that.$t("message.Profile picture updated successfully"),
            timer: 3000,
          });
        } catch (e) {
          console.log(e);
          loader.hide();
          swal.fire({
            type: "error",
            title: that.$t("message.Profile picture update error"),
            text: that.$t("message.Could not update the profile picture"),
            timer: 5000,
          });
        }
      }
    },
    async browseSignatures() {
      let that = this;
      let file = await chooser.getFile("image/*");

      if (file) {
        let loader = that.$loading.show({
          container: null,
          canCancel: false,
        });
        try {
          let response = await that.$store.dispatch("uploadFileToMinio", file);
          let user = JSON.parse(localStorage.user);
          let updateFields = {
            _id: user._id,
            signature: {
              image: response.fileId,
            },
          };
          user = await that.$store.dispatch("updateUserProfile", updateFields);
          localStorage.user = JSON.stringify(user);
          $("#signature-img").prop(
            "src",
            that.baseUrl + "/file/" + user.signature.image
          );
          loader.hide();

          swal.fire({
            type: "success",
            title: that.$t("message.Signature updated!"),
            text: that.$t("message.Signature updated successfully"),
            timer: 3000,
          });
        } catch (e) {
          console.log(e);
          loader.hide();
          swal.fire({
            type: "error",
            title: that.$t("message.Signature update error"),
            text: that.$t("message.Could not update the signature"),
            timer: 5000,
          });
        }
      }
    },
  },
};
</script>
<style scoped>
/deep/.browse-files-button {
  position: absolute;
  bottom: 2em;
  inset-inline-end: 50%;
  transform: translateX(4em);
}
[dir="rtl"] /deep/.browse-files-button {
  transform: translateX(-4em);
}
</style>
